export var EXTERNAL_SERVICE_NAME;
(function (EXTERNAL_SERVICE_NAME) {
  EXTERNAL_SERVICE_NAME["HELLOSIGN"] = "hellosign";
  EXTERNAL_SERVICE_NAME["CRA"] = "cra";
  EXTERNAL_SERVICE_NAME["EQUIFAX"] = "equifax";
  EXTERNAL_SERVICE_NAME["MPP"] = "mpp";
  EXTERNAL_SERVICE_NAME["FILOGIX"] = "filogix";
  EXTERNAL_SERVICE_NAME["NYLAS"] = "nylas";
  EXTERNAL_SERVICE_NAME["EXPERT"] = "expert";
  EXTERNAL_SERVICE_NAME["BEE"] = "bee";
  EXTERNAL_SERVICE_NAME["GLOBAL"] = "aws";
})(EXTERNAL_SERVICE_NAME || (EXTERNAL_SERVICE_NAME = {}));
export const OUTAGE_INCIDENT_STATUS = {
  DEGRADED: "degraded",
  OUTAGE: "outage",
  MAINTENANCE: "maintenance"
};